import PortServices from "@features/vessel-call/vessel-call-status/PortServices/grid/PortServices";
import PortServicesPage from "@pages/port-services/PortServicesPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getPortServicesRoutes = (): AppRoute => ({
  path: paths.portServices.index,
  protected: true,
  element: <PortServicesPage />,
  requiredPermissions: ["hasVesselCallAccess"], // to add the right permissions
  children: [{ index: true, element: <PortServices isPage={true} /> }],
});
